import React from 'react';
import Link from '../../components/Link';
import { useGetExcel } from '../../hooks/useGetExcel';
import { HttpErrorIgnore } from '../../../../global';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

type SaveToExcelButtonProps = {
    waiting?: boolean;
    setWait: (waiting: boolean) => void;
    onGetExcel: () => Promise<HttpErrorIgnore | undefined>;
};

const SaveToExcelButton = ({ waiting = false, setWait, onGetExcel }: SaveToExcelButtonProps): JSX.Element => {
    const { handleGetExcel } = useGetExcel({
        waiting,
        setWait,
        getExcel: onGetExcel,
    });

    return (
        <Link onClick={handleGetExcel}>
            <FontAwesomeIcon icon={faFileExcel} />
            Save to Excel
        </Link>
    );
};

export default SaveToExcelButton;
